<p-breadcrumb
  [model]="[
    { label: 'Áreas de Exibição', routerLink: ['/display-areas'] },
    {
      label: 'Editar Área de Exibição',
      routerLink: ['/display-areas/update', displayAreaId()]
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        <h5 class="font-bold">Editar Área de Exibição</h5>
        <p>Atualize as informações e os itens exibidos</p>
      </div>

      <div class="flex justify-end gap-2">
        <p-button
          label="Cancelar"
          routerLink="/display-areas"
          severity="secondary"
          rounded
          class="btn-secondary-outline"
        >
        </p-button>
        <p-button type="submit" label="Salvar" rounded></p-button>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="name">Nome *</label>
        <input
          pInputText
          type="text"
          formControlName="name"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="w-full">
        <label for="itemType">Tipo de item</label>
        <p-select
          formControlName="itemType"
          [options]="displayAreaTypeOptions"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        >
        </p-select>
      </div>
    </div>

    <div class="w-full">
      <label for="description">Descrição</label>
      <input
        pInputText
        type="text"
        formControlName="description"
        class="w-full"
        placeholder="Informe a descrição"
      />
      <app-form-error [control]="formGroup.get('description')" />
      <app-form-server-error [control]="formGroup.get('description')" />
    </div>
  </div>

  <div class="card space-y-5 w-full mt-5">
    <div class="flex justify-between items-center">
      <div>
        <h5 class="font-bold">Itens exibidos</h5>
        <p>
          Selecione até {{ maxItems() }} item(ns). Selecionados:
          {{ selectedCount }}.
        </p>
      </div>
    </div>

    @if (hasReachedMaxItems) {
    <div
      class="p-3 rounded-md border border-yellow-300 bg-yellow-50 text-yellow-800 text-sm"
    >
      Você atingiu o número máximo de {{ maxItems() }} item(ns) permitidos para
      esta área. Para selecionar outro item, remova um dos itens já
      selecionados.
    </div>
    } @if (itemsLoading()) {
    <div
      class="w-full flex items-center justify-center py-10 bg-black/5 rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading items" />
    </div>
    } @else {
    <p-table
      [value]="availableItems()"
      [paginator]="false"
      [rows]="availableItems().length"
      editable="true"
    >
      <ng-template #header>
        <tr>
          <th style="width: 4rem"></th>
          <th>Imagem</th>
          <th>Nome</th>
          <th>
            {{ hasItemSku ? "SKU" : "Descrição" }}
          </th>
          <th style="width: 7rem">Ordem</th>
        </tr>
      </ng-template>

      <ng-template #body let-item>
        <tr>
          <td class="text-center">
            <p-checkbox
              [binary]="true"
              [ngModel]="isSelected(item.id)"
              (onChange)="onToggleItem(item, $event.checked)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="hasReachedMaxItems && !isSelected(item.id)"
            >
            </p-checkbox>
          </td>
          <td>
            @if(item.imageUrl){
            <img [src]="item.imageUrl" alt="image" class="w-10" />
            }
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.description }}</td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  class="w-full text-center"
                  [ngModel]="getDisplayOrder(item.id)"
                  (ngModelChange)="onDisplayOrderChange(item.id, $event)"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!isSelected(item.id)"
                  min="0"
                />
              </ng-template>
              <ng-template pTemplate="output">
                <span class="block text-center">
                  {{ getDisplayOrder(item.id) }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
    </p-table>
    }
  </div>

  @if (loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</form>

<p-toast />
